import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=8c9f5ed4&scoped=true&"
import script from "./policy.vue?vue&type=script&lang=js&"
export * from "./policy.vue?vue&type=script&lang=js&"
import style0 from "./policy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./policy.vue?vue&type=style&index=1&id=8c9f5ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9f5ed4",
  null
  
)

export default component.exports